module.exports = __webpack_public_path__ + "static/img/161_TO8_1894.7c16036.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/161_TO8_1894.jpg
// module id = m+Zf
// module chunks = 0